module.exports = __webpack_public_path__ + "static/img/tc.d40761f2.svg";